import type React from 'react';

function SkrymIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 206.85 206.85"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <title>Skrym Icon</title>

      <g id="Layer_2-2" data-name="Layer 2">
        <rect width="206.85" height="206.85" fill="none" />
        <path d="M143.15,155.94H21.13c-5.77,0-10.46-4.69-10.46-10.46V23.46c0-5.77,4.69-10.46,10.46-10.46h122.02c5.77,0,10.46,4.69,10.46,10.46v122.02c0,5.77-4.69,10.46-10.46,10.46h0Zm-111.82-20.66h101.62V33.66H31.33v101.62Z" />
        <path d="M184.45,193.85H64.96c-6.46,0-11.72-5.26-11.72-11.72V62.64c0-6.46,5.26-11.72,11.72-11.72h119.49c6.46,0,11.72,5.26,11.72,11.72v119.49c0,6.46-5.26,11.72-11.72,11.72Zm-110.56-20.66h101.62V71.57H73.9v101.62Z" />
        <rect
          x="33.44"
          y="18.39"
          width="20.66"
          height="58.35"
          transform="translate(-20.72 51.99) rotate(-51.3)"
        />
        <rect
          x="152.08"
          y="132.58"
          width="20.66"
          height="61.73"
          transform="translate(-67.37 180.55) rotate(-49.44)"
        />
      </g>
    </svg>
  );
}

export default SkrymIcon;
